export const phases = {
  think: {
    name: 'Think',
    poem: 'Questions bloom like seeds / Scattered dots seek connection / Patterns start to form',
    description: 'Research & Discovery'
  },
  design: {
    name: 'Design',
    poem: 'Lines dance into grace / Structure meets imagination / Form follows meaning',
    description: 'Crafting Solutions'
  },
  develop: {
    name: 'Develop',
    poem: 'Code breathes life to dreams / Systematic precision flows / Building piece by piece',
    description: 'Engineering Excellence'
  },
  launch: {
    name: 'Launch',
    poem: 'Wings spread from the shell / Ideas soar into the world / Impact radiates',
    description: 'Release & Growth'
  },
  scale: {
    name: 'Scale',
    poem: 'Ripples become waves / Excellence multiplies outward / Growth feeds the cycle',
    description: 'Continuous Evolution'
  }
};

export const phaseKeys = Object.keys(phases);